import { useMutation } from "react-query";
import updateOrg from "../services/updateOrg";
import { CreateOrgRequest } from "../types/org.type"; // Import the type for type safety

// Define the mutation input type
interface UpdateOrgInput {
  id: string;
  data: CreateOrgRequest;
}

const useUpdateOrg = () => {
  return useMutation(
    ({ id, data }: UpdateOrgInput) => updateOrg(id, data), // Pass id and data to updateOrg
    {
      mutationKey: ["update-org"],
    }
  );
};

export default useUpdateOrg;